'use strict';

var React = require('react');
var Dom = require('react-dom');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var Border = require('../common/Border');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var propConst = require('../../constants/propConst');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');

var Button = React.createClass({

  //矫正边界
  adjustBounds: function () {
    var com;
    var parentDom;
    var size;
    var txDom;
    txDom = Dom.findDOMNode(this.refs.wrapText);
    if (this.props.isAutoSize) {
      com = Dom.findDOMNode(this);
      parentDom = com.parentElement;

      while (!parentDom && (parentDom.id !== this.props.controlID)) {
        parentDom = parentDom.parentElement;
      }

      if (parentDom) {
        size = AutoSizeHelper.getComAutoSize(this.props);
        $(parentDom).css({width: size.width + 12, height: size.height + 7});
      }
    }

    if (txDom) {
      this.doAdjus(txDom);
    } else {
      this.doSetLineHeight();
    }
  },

  doAdjus: function (dom) {
    var selfDom = Dom.findDOMNode(this);
    var h = selfDom.clientHeight;     // styleHelper.getHeight(this.props);
    var w = selfDom.clientWidth;      // styleHelper.getWidth(this.props);
    var hAlign = styleHelper.getPropertyValue(this.props, propConst.TEXT_ALIGN);
    var vAlign = styleHelper.getPropertyValue(this.props, propConst.TEXT_V_ALIGN);
    var tw = dom.clientWidth;
    var th = dom.clientHeight - styleHelper.getFontSize(this.props) * 0.2;
    var tl;
    var tt;
    var margin = 2;

    switch (hAlign) {
    case appTypes.HoriAlign.LEFT:
      tl = margin;
      break;
    case appTypes.HoriAlign.CENTER:
      tl = (w - tw) / 2;
      break;
    case appTypes.HoriAlign.RIGHT:
      tl = w - tw - margin;
      break;
    }
    switch (vAlign) {
    case appTypes.VertAlign.TOP:
      tt = margin;
      break;
    case appTypes.VertAlign.MIDDLE:
      tt = (h - th) / 2 - 2;
      break;
    case appTypes.VertAlign.BOTTOM:
      tt = h - th - margin;
      break;
    }
    $(dom).css({left: 1, top: tt});
    this.doSetLineHeight();
  },

  doSetLineHeight: function () {
    var textSize = styleHelper.getFontSize(this.props);
    var dom = Dom.findDOMNode(this);
    var h = dom.clientHeight;
    var lineHeight = styleHelper.builderLineHeight(this.props);
    if (!this.isMultiText) {
      if (this.props.textVAlign === 'VaTop') {
        lineHeight = textSize * 1 + 8;
      } else if (this.props.textVAlign === 'VaBottom') {
        lineHeight = h * 2 - textSize - 8;
      } else {
        lineHeight = h;
      }
    }
    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
    if (lineHeight) {
      $(dom).css({lineHeight: lineHeight + 'px'});
    } else {
      $(dom).css({
        lineHeight: '1em'
      })
    }
  },

  componentDidUpdate: function () {
    this.adjustBounds();
  },

  componentDidMount: function () {
    this.adjustBounds();
    $(Dom.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
  },

  onResize: function (e) {
    this.adjustBounds();
  },

  isMultiText: false,

  render: function () {
    var style;
    var wrap = this.props.textWordWrap;
    var text = styleHelper.getText(this.props);
    var isMultiline = this.props.textWordWrap || util.Text.isMultiLineText(text);
    var state = styleHelper.getPropertyValue(this.props, propConst.BUTTON_STATUS);
    style = styleHelper.StyleUtil(this.props).background().border().text().align().base().lineHeight(wrap).wrap(wrap).style;
    style.overflow = 'hidden';
    if (isMultiline) {
      this.isMultiText = true;
      style.whiteSpace = 'pre-wrap';
    } else {
      this.isMultiText = false;
    }
    if (state === appTypes.ButtonStatus.SELECTED) {
      style.backgroundColor = '#41c7d6';
    }

    if (this.props.isAutoTextColor) {
      if (util.Color.isLight(style.backgroundColor)) {
        style.color = '#000'
      } else {
        style.color = '#fff';
      }
    }
    var textStyle = {};
    styleHelper.builderTextStyle(this.props, textStyle);
    if (isMultiline) {
      textStyle = _.extend(textStyle, {
        padding: 0,
        margin: 0,
        wordBreak: 'break-word'
      });
    }
    return (
      <diy style={style} key="_" className="component component-button">
        {isMultiline
          ?
          <div ref="wrapText"
               style={{left: 1, right: 1, top: 0, height: 'auto', position: 'absolute', lineHeight: style.lineHeight}}>
            <p style={textStyle}>{text}</p>
          </div>
          :
          <label style={textStyle}>{text}</label>
        }
      </diy>
    )
  }
});

module.exports = Button;



// WEBPACK FOOTER //
// ./src/views/Components/Button.jsx